import type { SearchIndex } from '../type';
import { SEARCH_CATEGORIES } from '../config';

/**
 * Get the search category config from the search index.
 * @param index The index to get the search category config for.
 * @returns The search category config.
 */
function getSearchCategoryConfigFromIndex(index: SearchIndex | undefined) {
    if (!index) {
        return undefined;
    }
    return SEARCH_CATEGORIES.find((cfg) => cfg.index === index);
}

/**
 * Get the search category config from the search category.
 * @param category The category to get the search category config for.
 * @returns The search category config.
 */
function getSearchCategoryConfigFromCategory(category: string | undefined) {
    if (!category) {
        return undefined;
    }
    return SEARCH_CATEGORIES.find((cfg) => cfg.category === category);
}

/**
 * Get the search category from the search index.
 * @param index The index to get the search category for.
 * @returns The search category.
 */
export function getSearchCategoryFromIndex(index: SearchIndex | undefined) {
    return getSearchCategoryConfigFromIndex(index)?.category;
}

/**
 * Get the search category label from the search index.
 * @param index The index to get the search category label for.
 * @returns The search category label.
 */
export function getSearchCategoryLabelFromIndex(
    index: SearchIndex | undefined,
) {
    return getSearchCategoryConfigFromIndex(index)?.children;
}

/**
 * Get the search index from the search category.
 * @param category The category to get the search index for.
 * @returns The search index.
 */
export function getSearchIndexFromCategory(category: string | undefined) {
    return getSearchCategoryConfigFromCategory(category)?.index;
}
